import React, { useEffect } from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useTheme } from '@mui/material/styles';
import { useOnboarding } from '../contexts/OnboardingContext';
import { getTourConfig } from '../config/tourConfig';

const OnboardingTour = () => {
    const theme = useTheme();
    const {
        activeTour,
        runTour,
        stepIndex,
        completeTour,
        stopTour,
        setStepIndex
    } = useOnboarding();

    const tourConfig = getTourConfig(theme);
    const steps = activeTour ? tourConfig[activeTour] : [];

    const handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;

        if (type === EVENTS.STEP_AFTER) {
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        } else if (type === EVENTS.TARGET_NOT_FOUND) {
            // Skip missing targets gracefully — wait briefly then advance
            setTimeout(() => {
                setStepIndex(index + 1);
            }, 300);
        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            if (activeTour) {
                completeTour(activeTour);
            } else {
                stopTour();
            }
        }
    };

    if (!activeTour || !runTour || !steps || steps.length === 0) return null;

    return (
        <Joyride
            steps={steps}
            run={runTour}
            stepIndex={stepIndex}
            continuous
            showProgress
            showSkipButton
            disableScrolling
            spotlightPadding={8}
            floaterProps={{ disableAnimation: true }}
            callback={handleJoyrideCallback}
            styles={{
                options: {
                    arrowColor: theme.palette.background.paper,
                    backgroundColor: theme.palette.background.paper,
                    overlayColor: 'rgba(0, 0, 0, 0.75)',
                    primaryColor: theme.palette.primary.main,
                    textColor: theme.palette.text.primary,
                    zIndex: 10000,
                },
                tooltip: {
                    borderRadius: 16,
                    padding: 24,
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                },
                tooltipContainer: {
                    textAlign: 'left',
                },
                tooltipTitle: {
                    fontWeight: 800,
                    fontSize: '1.2rem',
                    marginBottom: 12,
                },
                tooltipContent: {
                    fontSize: '1rem',
                    lineHeight: 1.6,
                },
                buttonNext: {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    borderRadius: 8,
                    padding: '10px 20px',
                    fontWeight: 700,
                    outline: 'none',
                    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.4)',
                },
                buttonBack: {
                    color: theme.palette.text.secondary,
                    marginRight: 10,
                    fontWeight: 600,
                },
                buttonSkip: {
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                },
            }}
            locale={{
                last: 'Get Started',
                skip: 'Later',
            }}
        />
    );
};

export default OnboardingTour;
